import {useState, useEffect} from 'react';
import {Box, Grid, Container, Typography} from '@mui/material';
// components
import Page from '../components/Page';
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates,
  AppContributionValue
} from '../components/_dashboard/app';
import {asyncRequest} from 'src/services/network';
import {useNavigate} from 'react-router';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    revenue: 0,
    orders: 0,
    users: 0,
    charges: 0,

    payedOrders: 0,
    withdraws: 0
  });

  useEffect(() => {
    getStats();
    getAdminShow()
  }, []);

  function getAdminShow() {
    let admin = JSON.parse(localStorage.getItem('admin-userInfo'))
    if (admin.hasHomePage) {
      return admin.hasHomePage
    } else {
      return admin.hasHomePage
    }
  }

  async function getStats() {
    const {data} = await asyncRequest({
      method: 'get',
      path: '/stats'
    });

    setStats(data);
  }


  return (
    <Page title="控制台 | 首页">
      <Container maxWidth="xl">
        <Box sx={{pb: 5}}>
          <Typography variant="h4">欢迎回来</Typography>
        </Box>
        {getAdminShow() && (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <AppItemOrders title="今日新增用户" num={stats.users || 0} onClick={() => {
                navigate('/user/list')
              }}/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppNewUsers title="今日支付笔数" num={stats.payedOrders || 0} onClick={() => {
                navigate('/finance/transaction/list')
              }}/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppWeeklySales title="今日营业额" num={stats.totalPayed || 0} onClick={() => {
                navigate('/finance/transaction/list')
              }}/>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <AppBugReports title="今日新增商户" num={stats.merchantsAdded || 0} onClick={() => {
                navigate('/merchant/list')
              }}/>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3}>
            <AppBugReports title="平台剩余1.0消费券" num={stats.totalBalance || 0} onClick={() => {
              navigate('/finance/balance/list')
            }} />
          </Grid> */}

            <Grid item xs={12} sm={6} md={3}>
              <AppNewUsers title="平台剩余权益金" num={stats.totalBalanceV2 || 0} onClick={() => {
                navigate('/finance/balance/list')
              }}/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppBugReports title="平台剩余消费券" num={stats.totalXfqV2 || 0} onClick={() => {
                navigate('/finance/balance/list')
              }}/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppBugReports title="平台剩余兑换券" num={stats.totalDhqV2 || 0} onClick={() => {
                navigate('/finance/balance/list')
              }}/>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <AppContributionValue title="平台资金池一览"
                                    totalCV={stats.totalCV || 0}
                                    cvPrice={stats.cvPrice || 0}
                                    cvFundPool={stats.cvFundPool || 0}
                                    totalPinTuanCV={stats.totalPinTuanCV || 0}
                                    pinTuanCvPrice={stats.pinTuanCvPrice || 0}
                                    pinTuanCvFundPool={stats.pinTuanCvFundPool || 0}
                                    onClick={() => {
                                      navigate('/finance/point/list')
                                    }}/>
            </Grid>


            <Grid item xs={12} md={6} lg={8}>
              <AppWebsiteVisits/>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <AppCurrentVisits/>
            </Grid>

            {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid> */}

            {/* <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid> */}

          </Grid>
        )}
        {!getAdminShow() && (
          <Grid container spacing={3}>
            <div style={{height: '500px', textAlign: 'center', width: '100%', marginTop: '24px'}}>
              <img style={{width: '200px', height: '200px', display: 'inline-block'}}
                   src={`${process.env.PUBLIC_URL}/static/logo.svg`}/>
              <p style={{height: '200px', fontWeight: '600', fontSize: '28px'}}>鲸世优选</p>
            </div>
          </Grid>
        )}
      </Container>
    </Page>
  );
}
